import { Link } from "react-router-dom";
import { Button } from "@/components/Button";

export function NotFoundPage() {
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center gap-4 text-center">
      <div className="text-7xl">404</div>
      <h1 className="text-xl font-semibold text-slate-800 dark:text-slate-200">Página não encontrada</h1>
      <p className="max-w-md text-sm text-slate-500 dark:text-slate-400">
        O endereço acessado não existe (ou foi movido). Volta pra home.
      </p>
      <Link to="/">
        <Button variant="primary">Ir pro dashboard</Button>
      </Link>
    </div>
  );
}
